import { Button, ClickAwayListener, DialogActions, InputAdornment, TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { MultiSectionDigitalClock } from '@mui/x-date-pickers/MultiSectionDigitalClock';
import moment from 'moment';
import { useState } from 'react';

export function OutboundPickers({ setDate, date, setTime, time, disabled, showDatePicker = true }) {
    const [isOpen, setIsOpen] = useState(false);
    const [showDigitalClock, setShowDigitalClock] = useState(false);

    const MyActionBar = () => {
        return (
            <DialogActions>
                <Button onClick={() => setDate(moment().add(1, 'day'))} className='!text-journeyAlertsPurple'>Tomorrow</Button>
                <Button onClick={() => setDate(moment())} className='!text-journeyAlertsPurple'>Today</Button>
            </DialogActions>
        );
    };

    return (
        <div className={`flex flex-row gap-4 flex-shrink min-w-[18rem] max-w-2xs ${!showDatePicker ? 'justify-between' : ''}`}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                {showDatePicker && (
                    <MobileDatePicker
                        disabled={disabled}
                        format="DD/MM/YYYY"
                        minDate={moment()}
                        value={date}
                        closeOnSelect={true}
                        onChange={(newValue) => setDate(newValue)}
                        open={isOpen}
                        onClose={() => setIsOpen(false)}
                        slots={{
                            actionBar: MyActionBar,
                        }}
                        orientation='portrait'
                        slotProps={{
                            toolbar: {
                                hidden: true
                            },
                            textField: {
                                variant: 'standard',
                                InputProps: {
                                    onClick: () => !disabled && setIsOpen(true),
                                    classes: { input: 'border-none', disabled: '!text-gray-400 !cursor-not-allowed' },
                                    endAdornment: <i className="zip-icon zip-icon-int_datepicker text-xl sm:text-2xl"></i>,
                                    sx: { fontSize: '1rem !important' }
                                },
                                InputLabelProps: {
                                    sx: { fontFamily: 'CoHeadline', color: 'black' }
                                },
                            }
                        }}
                    />
                )}

                <div className={`${!showDatePicker ? 'w-20 sm:w-24 md:w-28' : ''}`}>
                    <TextField
                        disabled={disabled}
                        sx={{
                            input: {
                                fontFamily: 'CoHeadline',
                                fontSize: '1rem !important'
                            }
                        }}
                        onClick={() => !disabled && setShowDigitalClock(!showDigitalClock)}
                        value={time ? time.format('HH:mm') : ''}
                        variant="standard"
                        inputProps={{
                            readOnly: true,
                            className: 'cursor-pointer ' + (disabled ? '!text-gray-400 !cursor-not-allowed' : '')
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <i className="zip-icon zip-icon-int_timepicker text-xl sm:text-2xl"></i>
                                </InputAdornment>
                            )

                        }}
                        InputLabelProps={{
                            sx: { fontFamily: 'CoHeadline', color: 'black', fontWeight: 700 }
                        }}
                    />

                    {showDigitalClock &&
                        <div className='timeWrapper'>
                            <ClickAwayListener onClickAway={() => showDigitalClock && setShowDigitalClock(false)}>
                                <MultiSectionDigitalClock
                                    disabled={disabled}
                                    ampm={false}
                                    onChange={(newValue) => setTime(newValue)}
                                    value={time}
                                    timeSteps={{ minutes: 15 }}
                                />
                            </ClickAwayListener>
                        </div>
                    }
                </div>
            </LocalizationProvider>
        </div>
    );
}